import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getCategory } from 'Services/Features/Category/Utils/categoryUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindCategory from './Filter/FindCategory';
import CategoryContent from './CategoryContent';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters } from 'Services/Features/Category/categorySlice';

const CategoryContain = () => {
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.category.categories);
    const loading = useSelector((state) => state.category.loading);
    const error = useSelector((state) => state.category.error);
    const [refetch, setRefetch] = useState(false);
    const pagination = useSelector((state) => state.category.pagination);
    const filters = useSelector(state => state.category.filters);

    useEffect(() => {
        dispatch(getCategory(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindCategory />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && categories.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Kategori Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <Col sm="12">
                            <CategoryContent setRefetch={setRefetch} />
                        </Col>
                    )}
                </Row>
                <div style={{ marginTop: '150px' }}>
                    {loading === false && categories && categories.length > 0 && (
                        <PaginationComponent
                            pagination={pagination}
                            handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                            handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                            handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        />
                    )}
                </div>
            </Col>
        </Fragment>
    );
};

export default CategoryContain;